import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createUpdateMttFromIdOutbound } from '../../api/outbound/lobbyOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { FormControlContainer } from '../formControlContainer';
import { OpenModalContainer } from '../openModalContainer';
export const MttToolsModal = ({ onClose }) => {
    const socketSend = useSocketSend();
    const [mttIdStr, setMttIdStr] = useState('');
    const onChangeMttId = (event) => {
        setMttIdStr(event.target.value);
    };
    const onClickUpdateMttId = useCallback(() => {
        const mttId = Number(mttIdStr);
        if (!isNaN(mttId)) {
            onClose();
            socketSend(createUpdateMttFromIdOutbound(mttId));
        }
    }, [onClose, mttIdStr, socketSend]);
    return (_jsx(OpenModalContainer, { title: 'MTT Tools', onClose: onClose, maxWidth: 'md', children: _jsx(DialogContent, { children: _jsxs(FormControlContainer, { isFlex: true, children: [_jsx(TextField, { variant: 'filled', label: 'Update MTT ID from DB', value: mttIdStr, onChange: onChangeMttId }), _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickUpdateMttId, children: "Update" })] }) }) }));
};
